import { useContext, useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { UserContext } from "../context/UserContext";
import Header from "../components/Header";
import FooterSection from "../components/FooterSection";
import PagesHero from "../components/PagesHero";
import FreeOddSection from "../components/FreeOddSection";
import axios from "axios";
// import MsportModal from "../components/MsportModal";

// import PreviousWinsSection from "../components/PreviewsWinsSection";
// import axios from "axios";

function Premium() {
  const { user } = useContext(UserContext);
  const [userSubscription, setUserSubscription] = useState({
    Premium: false,
  });
  // const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (user) {
      axios
        .get(`/auth/profile/${user?.id}`)
        .then(({ data }) => {
          if (data) {
            setUserSubscription(data.subscription);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [user, setUserSubscription]);

  const isSubscribed =
    userSubscription && new Date(userSubscription.expiresAt) > new Date();

  return (
    <div>
      {/* {showModal && <MsportModal setShowModal={setShowModal} />} */}

      <Header />
      <PagesHero page={"Premium"} />

      {isSubscribed ? (
        <FreeOddSection title={"premium"} header="VIP Prediction" />
      ) : (
        <div className="unsub_card">
          <h3>VIP Access Required</h3>
          <p>
            Upgrade to VIP for exclusive daily premium predictions, in-depth
            analysis, and higher-value tips. Subscribe now to unlock all premium
            picks and tools.
          </p>
          <div className="unsub_actions">
            <NavLink to="/plan" className="btn btn_submit">
              Subscribe Now
            </NavLink>
            <NavLink to="/contact" className="btn btn_border">
              Contact Support
            </NavLink>
          </div>
          <small className="unsub_note">
            Already subscribed? Sign in or refresh the page to access your VIP
            predictions.
          </small>
        </div>
      )}

      {/* <PreviousWinsSection results={expertResult} /> */}
      <FooterSection />
    </div>
  );
}

export default Premium;
